<template>
<!-- 退出AlongShare?-->
  <el-dialog
      :width="this.screenWidth<768.98?'85%':'500px'"
      append-to-body
      :show-close="false"
      :title="$t('userinfo.exitalongshare')"
      :visible.sync="dialogFormVisible"
      :close-on-press-escape="false"
      :close-on-click-modal="false">
    <div slot="footer" class="dialog-footer">
      <!-- 取消-->
      <el-button @click="closeDialog">{{$t('friends.cancel')}}</el-button>
      <!-- 是的-->
      <el-button type="primary" @click="logOut">{{$t('luckdraw.comfirm')}}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  logoutToken
} from "@/request/requests";
export default {
  name: "logOut",
  data(){
    return{
      dialogFormVisible: false,
      screenWidth: null
    }
  },
  methods:{
    init(){
      this.dialogFormVisible = true;
    },
    async logOut() {
      await logoutToken();
      this.$cookies.remove('token');
      this.$cookies.remove('userInfo');
      this.$cookies.remove('deadline');
      localStorage.removeItem("lang");
      if ("ontouchstart" in document.documentElement) {
        this.$router.push({name: "phonehome"});
      } else {
        this.$router.push({name: "home"});
      }
      this.$emit('logOut');
      this.closeDialog();
    },
    closeDialog(){
      this.dialogFormVisible = false;
    },
    calcWidth() {
      this.screenWidth = window.screen.width;
      this.$forceUpdate();
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.calcWidth();
      window.addEventListener("resize", this.calcWidth);
    })
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calcWidth);
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog{
  margin-top:0!important;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  &__title{
    font-weight:700;
    font-size: 20px;
    @media(max-width:575.98px){
      font-size: 16px;
    }
  }
  .el-button{
    font-size:14px;
    padding: 20px 40px !important;
    border-radius: 34px !important;
    width: calc(100% / 2 - 20px);
    @media(max-width:575.98px){
      padding:10px 40px!important;
    }
  }
  &__header{
    text-align: center;
    padding-bottom:24px;
  }
  &__body{
    padding:0;
  }
  &__footer{
    text-align: left!important;
  }
}
.dialog-footer{
  display: flex;
  align-items: center;
  justify-content: space-between;
}

</style>